import channels from "./channels";

export const digisessionChannels = [channels.claro_pix_incentivo];

export default digisessionChannels;
